export * from './full-layout.component';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/containers/full-layout/index.ts